const errorMessages = {
    timedOut: 'Connection timed out',
    notConnected: 'Not connected to a device',
    charNotFound: 'Characteristic not found on device',
    notBonded: 'Bonding is required',
    bleDisabled: 'Bluetooth is disabled',
    noBleAvailable: 'Bluetooth is not available',
    gatt: 'GATT error',
};
export class BleDeviceError extends Error {
    cause;
    info;
    static causeFromAny(err) {
        return err instanceof BleDeviceError ? err.cause : undefined;
    }
    constructor(cause, info) {
        super(errorMessages[cause] + (info ? ' ' + info : ''));
        this.cause = cause;
        this.info = info;
    }
}
//# sourceMappingURL=interface.js.map